"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionType = exports.SigninTokenType = exports.SigninKeyScopeType = exports.AccountType = exports.Permissions = exports.EventType = exports.GroupTarget = exports.ProspectiveMemberPasswordCreationType = exports.EmailSentType = exports.PasswordSetResult = exports.PasswordResult = exports.CAPWATCHImportUpdate = exports.CustomAttendanceFieldEntryType = exports.NotificationDataType = exports.NotificationCauseType = exports.NotificationTargetType = exports.FileUserAccessControlType = exports.FileUserAccessControlPermissions = exports.PopulateGoogleCalendarErrors = exports.AuditableEventType = exports.AttendanceStatus = exports.CAPWATCHImportErrors = exports.MemberCAPWATCHErrors = exports.CAPProspectiveMemberPasswordCreationType = exports.TeamPublicity = exports.PointOfContactType = exports.MemberCreateError = exports.EchelonEventNumber = exports.EventStatus = exports.NHQ = void 0;
const NHQ = require("./nhq/index");
exports.NHQ = NHQ;
var EventStatus;
(function (EventStatus) {
    EventStatus["DRAFT"] = "Draft";
    EventStatus["TENTATIVE"] = "Tentative";
    EventStatus["CONFIRMED"] = "Confirmed";
    EventStatus["COMPLETE"] = "Complete";
    EventStatus["CANCELLED"] = "Cancelled";
    EventStatus["INFORMATIONONLY"] = "InformationOnly";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
var EchelonEventNumber;
(function (EchelonEventNumber) {
    EchelonEventNumber[EchelonEventNumber["NOT_REQUIRED"] = 0] = "NOT_REQUIRED";
    EchelonEventNumber[EchelonEventNumber["TO_BE_APPLIED_FOR"] = 1] = "TO_BE_APPLIED_FOR";
    EchelonEventNumber[EchelonEventNumber["APPLIED_FOR"] = 2] = "APPLIED_FOR";
    EchelonEventNumber[EchelonEventNumber["DENIED"] = 3] = "DENIED";
    EchelonEventNumber[EchelonEventNumber["APPROVED"] = 4] = "APPROVED";
})(EchelonEventNumber = exports.EchelonEventNumber || (exports.EchelonEventNumber = {}));
var MemberCreateError;
(function (MemberCreateError) {
    MemberCreateError["NONE"] = "None";
    MemberCreateError["INCORRRECT_CREDENTIALS"] = "IncorrectCredentials";
    MemberCreateError["SERVER_ERROR"] = "ServerError";
    MemberCreateError["PASSWORD_EXPIRED"] = "PasswordExpired";
    MemberCreateError["INVALID_SESSION_ID"] = "InvalidSessionID";
    MemberCreateError["RECAPTCHA_INVALID"] = "TokenInvalid";
    MemberCreateError["UNKOWN_SERVER_ERROR"] = "UnknownServerError";
    MemberCreateError["DATABASE_ERROR"] = "DatabaseError";
    MemberCreateError["ACCOUNT_USES_MFA"] = "MFAChallengeRequired";
    MemberCreateError["ACCOUNT_EXPIRED"] = "AccountExpired";
})(MemberCreateError = exports.MemberCreateError || (exports.MemberCreateError = {}));
var PointOfContactType;
(function (PointOfContactType) {
    PointOfContactType["INTERNAL"] = "Internal";
    PointOfContactType["EXTERNAL"] = "External";
})(PointOfContactType = exports.PointOfContactType || (exports.PointOfContactType = {}));
var TeamPublicity;
(function (TeamPublicity) {
    TeamPublicity["PRIVATE"] = "Private";
    TeamPublicity["PROTECTED"] = "Protected";
    TeamPublicity["PUBLIC"] = "Public";
})(TeamPublicity = exports.TeamPublicity || (exports.TeamPublicity = {}));
var CAPProspectiveMemberPasswordCreationType;
(function (CAPProspectiveMemberPasswordCreationType) {
    CAPProspectiveMemberPasswordCreationType["WITHPASSWORD"] = "WithPassword";
    CAPProspectiveMemberPasswordCreationType["EMAILLINK"] = "EmailLink";
    CAPProspectiveMemberPasswordCreationType["RANDOMPASSWORD"] = "RandomPassword";
})(CAPProspectiveMemberPasswordCreationType = exports.CAPProspectiveMemberPasswordCreationType || (exports.CAPProspectiveMemberPasswordCreationType = {}));
var MemberCAPWATCHErrors;
(function (MemberCAPWATCHErrors) {
    MemberCAPWATCHErrors["INVALID_PERMISSIONS"] = "InvalidPermissions";
    MemberCAPWATCHErrors["NO_NHQ_ACTION"] = "NoNHQAction";
})(MemberCAPWATCHErrors = exports.MemberCAPWATCHErrors || (exports.MemberCAPWATCHErrors = {}));
var CAPWATCHImportErrors;
(function (CAPWATCHImportErrors) {
    CAPWATCHImportErrors["NONE"] = "None";
    CAPWATCHImportErrors["BADDATA"] = "BadData";
    CAPWATCHImportErrors["INSERT"] = "BadInsert";
    CAPWATCHImportErrors["CLEAR"] = "BadClear";
    CAPWATCHImportErrors["NOPERMISSIONS"] = "BadPerms";
})(CAPWATCHImportErrors = exports.CAPWATCHImportErrors || (exports.CAPWATCHImportErrors = {}));
var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus["COMMITTEDATTENDED"] = "CommittedAttended";
    AttendanceStatus["NOSHOW"] = "NoShow";
    AttendanceStatus["RESCINDEDCOMMITMENTTOATTEND"] = "RescindedCommitment";
    AttendanceStatus["NOTPLANNINGTOATTEND"] = "NotPlanningToAttend";
})(AttendanceStatus = exports.AttendanceStatus || (exports.AttendanceStatus = {}));
var AuditableEventType;
(function (AuditableEventType) {
    AuditableEventType["MODIFY"] = "Modify";
    AuditableEventType["ADD"] = "Add";
    AuditableEventType["DELETE"] = "Delete";
})(AuditableEventType = exports.AuditableEventType || (exports.AuditableEventType = {}));
var PopulateGoogleCalendarErrors;
(function (PopulateGoogleCalendarErrors) {
    PopulateGoogleCalendarErrors["NONE"] = "None";
    PopulateGoogleCalendarErrors["INSERT"] = "InsertError";
    PopulateGoogleCalendarErrors["NOPERMISSIONS"] = "NoPermissions";
})(PopulateGoogleCalendarErrors = exports.PopulateGoogleCalendarErrors || (exports.PopulateGoogleCalendarErrors = {}));
var FileUserAccessControlPermissions;
(function (FileUserAccessControlPermissions) {
    FileUserAccessControlPermissions[FileUserAccessControlPermissions["READ"] = 1] = "READ";
    FileUserAccessControlPermissions[FileUserAccessControlPermissions["WRITE"] = 2] = "WRITE";
    FileUserAccessControlPermissions[FileUserAccessControlPermissions["MODIFY"] = 4] = "MODIFY";
    FileUserAccessControlPermissions[FileUserAccessControlPermissions["FULLCONTROL"] = 255] = "FULLCONTROL";
})(FileUserAccessControlPermissions = exports.FileUserAccessControlPermissions || (exports.FileUserAccessControlPermissions = {}));
var FileUserAccessControlType;
(function (FileUserAccessControlType) {
    FileUserAccessControlType["USER"] = "User";
    FileUserAccessControlType["TEAM"] = "Team";
    FileUserAccessControlType["ACCOUNTMEMBER"] = "AccountMember";
    FileUserAccessControlType["SIGNEDIN"] = "SignedIn";
    FileUserAccessControlType["OTHER"] = "Public";
})(FileUserAccessControlType = exports.FileUserAccessControlType || (exports.FileUserAccessControlType = {}));
var NotificationTargetType;
(function (NotificationTargetType) {
    NotificationTargetType["MEMBER"] = "Member";
    NotificationTargetType["ADMINS"] = "Admins";
    NotificationTargetType["EVERYONE"] = "Everyone";
})(NotificationTargetType = exports.NotificationTargetType || (exports.NotificationTargetType = {}));
var NotificationCauseType;
(function (NotificationCauseType) {
    NotificationCauseType["MEMBER"] = "Member";
    NotificationCauseType["SYSTEM"] = "System";
})(NotificationCauseType = exports.NotificationCauseType || (exports.NotificationCauseType = {}));
var NotificationDataType;
(function (NotificationDataType) {
    NotificationDataType["PROSPECTIVEMEMBER"] = "ProspectiveMember";
    NotificationDataType["PERSONNELFILES"] = "PersonnelFiles";
    NotificationDataType["EVENT"] = "Event";
    NotificationDataType["PERMISSIONCHANGE"] = "PermissionChange";
    NotificationDataType["MESSAGE"] = "Message";
})(NotificationDataType = exports.NotificationDataType || (exports.NotificationDataType = {}));
var CustomAttendanceFieldEntryType;
(function (CustomAttendanceFieldEntryType) {
    CustomAttendanceFieldEntryType["TEXT"] = "Text";
    CustomAttendanceFieldEntryType["NUMBER"] = "Number";
    CustomAttendanceFieldEntryType["DATE"] = "Date";
    CustomAttendanceFieldEntryType["CHECKBOX"] = "Checkbox";
    CustomAttendanceFieldEntryType["FILE"] = "File";
    CustomAttendanceFieldEntryType["QUAL"] = "Qual";
})(CustomAttendanceFieldEntryType = exports.CustomAttendanceFieldEntryType || (exports.CustomAttendanceFieldEntryType = {}));
var CAPWATCHImportUpdate;
(function (CAPWATCHImportUpdate) {
    CAPWATCHImportUpdate["CAPWATCHFileDownloaded"] = "Downloaded";
    CAPWATCHImportUpdate["FileImported"] = "Imported";
    CAPWATCHImportUpdate["CAPWATCHFileDone"] = "Done";
    CAPWATCHImportUpdate["ProgressInitialization"] = "Init";
})(CAPWATCHImportUpdate = exports.CAPWATCHImportUpdate || (exports.CAPWATCHImportUpdate = {}));
var PasswordResult;
(function (PasswordResult) {
    PasswordResult["VALID"] = "Valid";
    PasswordResult["VALID_EXPIRED"] = "Expired";
    PasswordResult["INVALID"] = "Invalid";
})(PasswordResult = exports.PasswordResult || (exports.PasswordResult = {}));
var PasswordSetResult;
(function (PasswordSetResult) {
    PasswordSetResult["OK"] = "Ok";
    PasswordSetResult["IN_HISTORY"] = "InHistory";
    PasswordSetResult["COMPLEXITY"] = "Complexity";
    PasswordSetResult["MIN_AGE"] = "MinimumAge";
    PasswordSetResult["SERVER_ERROR"] = "ServerError";
})(PasswordSetResult = exports.PasswordSetResult || (exports.PasswordSetResult = {}));
var EmailSentType;
(function (EmailSentType) {
    EmailSentType["TOPARENT"] = "ToParent";
    EmailSentType["TOCADET"] = "ToCadet";
})(EmailSentType = exports.EmailSentType || (exports.EmailSentType = {}));
var ProspectiveMemberPasswordCreationType;
(function (ProspectiveMemberPasswordCreationType) {
    ProspectiveMemberPasswordCreationType["WITHPASSWORD"] = "WithPassword";
    ProspectiveMemberPasswordCreationType["EMAILLINK"] = "WithEmailLink";
    ProspectiveMemberPasswordCreationType["RANDOMPASSWORD"] = "WithRandomPassword";
})(ProspectiveMemberPasswordCreationType = exports.ProspectiveMemberPasswordCreationType || (exports.ProspectiveMemberPasswordCreationType = {}));
var GroupTarget;
(function (GroupTarget) {
    GroupTarget["NONE"] = "None";
    GroupTarget["FLIGHT"] = "Flight";
    GroupTarget["ACCOUNT"] = "Account";
})(GroupTarget = exports.GroupTarget || (exports.GroupTarget = {}));
var EventType;
(function (EventType) {
    EventType["REGULAR"] = "Regular";
    EventType["LINKED"] = "Linked";
})(EventType = exports.EventType || (exports.EventType = {}));
var Permissions;
(function (Permissions) {
    let FlightAssign;
    (function (FlightAssign) {
        FlightAssign["NO"] = "No";
        FlightAssign["YES"] = "Yes";
    })(FlightAssign = Permissions.FlightAssign || (Permissions.FlightAssign = {}));
    let MusterSheet;
    (function (MusterSheet) {
        MusterSheet["NO"] = "No";
        MusterSheet["YES"] = "Yes";
    })(MusterSheet = Permissions.MusterSheet || (Permissions.MusterSheet = {}));
    let PTSheet;
    (function (PTSheet) {
        PTSheet["NO"] = "No";
        PTSheet["YES"] = "Yes";
    })(PTSheet = Permissions.PTSheet || (Permissions.PTSheet = {}));
    let PromotionManagement;
    (function (PromotionManagement) {
        PromotionManagement["NONE"] = "None";
        PromotionManagement["FULL"] = "Full";
    })(PromotionManagement = Permissions.PromotionManagement || (Permissions.PromotionManagement = {}));
    let AssignTasks;
    (function (AssignTasks) {
        AssignTasks["NO"] = "No";
        AssignTasks["YES"] = "Yes";
    })(AssignTasks = Permissions.AssignTasks || (Permissions.AssignTasks = {}));
    let AdministerPT;
    (function (AdministerPT) {
        AdministerPT["NO"] = "No";
        AdministerPT["YES"] = "Yes";
    })(AdministerPT = Permissions.AdministerPT || (Permissions.AdministerPT = {}));
    let ManageEvent;
    (function (ManageEvent) {
        ManageEvent["NONE"] = "None";
        ManageEvent["ADDDRAFTEVENTS"] = "AddDraftEvents";
        ManageEvent["FULL"] = "Full";
    })(ManageEvent = Permissions.ManageEvent || (Permissions.ManageEvent = {}));
    let EventContactSheet;
    (function (EventContactSheet) {
        EventContactSheet["NO"] = "No";
        EventContactSheet["YES"] = "Yes";
    })(EventContactSheet = Permissions.EventContactSheet || (Permissions.EventContactSheet = {}));
    let ORMOPORD;
    (function (ORMOPORD) {
        ORMOPORD["NO"] = "No";
        ORMOPORD["YES"] = "Yes";
    })(ORMOPORD = Permissions.ORMOPORD || (Permissions.ORMOPORD = {}));
    let AssignTemporaryDutyPosition;
    (function (AssignTemporaryDutyPosition) {
        AssignTemporaryDutyPosition["NO"] = "No";
        AssignTemporaryDutyPosition["YES"] = "Yes";
    })(AssignTemporaryDutyPosition = Permissions.AssignTemporaryDutyPosition || (Permissions.AssignTemporaryDutyPosition = {}));
    let ProspectiveMemberManagement;
    (function (ProspectiveMemberManagement) {
        ProspectiveMemberManagement["NONE"] = "None";
        ProspectiveMemberManagement["FULL"] = "Full";
    })(ProspectiveMemberManagement = Permissions.ProspectiveMemberManagement || (Permissions.ProspectiveMemberManagement = {}));
    let EventLinkList;
    (function (EventLinkList) {
        EventLinkList["NO"] = "No";
        EventLinkList["YES"] = "Yes";
    })(EventLinkList = Permissions.EventLinkList || (Permissions.EventLinkList = {}));
    let ManageTeam;
    (function (ManageTeam) {
        ManageTeam["NONE"] = "None";
        ManageTeam["FULL"] = "Full";
    })(ManageTeam = Permissions.ManageTeam || (Permissions.ManageTeam = {}));
    let FileManagement;
    (function (FileManagement) {
        FileManagement["NONE"] = "None";
        FileManagement["FULL"] = "Full";
    })(FileManagement = Permissions.FileManagement || (Permissions.FileManagement = {}));
    let PermissionManagement;
    (function (PermissionManagement) {
        PermissionManagement["NONE"] = "None";
        PermissionManagement["FULL"] = "Full";
    })(PermissionManagement = Permissions.PermissionManagement || (Permissions.PermissionManagement = {}));
    let DownloadCAPWATCH;
    (function (DownloadCAPWATCH) {
        DownloadCAPWATCH["NO"] = "No";
        DownloadCAPWATCH["YES"] = "Yes";
    })(DownloadCAPWATCH = Permissions.DownloadCAPWATCH || (Permissions.DownloadCAPWATCH = {}));
    let Notify;
    (function (Notify) {
        Notify["NO"] = "No";
        Notify["GLOBAL"] = "Global";
    })(Notify = Permissions.Notify || (Permissions.Notify = {}));
    let RegistryEdit;
    (function (RegistryEdit) {
        RegistryEdit["NO"] = "No";
        RegistryEdit["YES"] = "Yes";
    })(RegistryEdit = Permissions.RegistryEdit || (Permissions.RegistryEdit = {}));
    let ScanAdd;
    (function (ScanAdd) {
        ScanAdd["NO"] = "No";
        ScanAdd["YES"] = "Yes";
    })(ScanAdd = Permissions.ScanAdd || (Permissions.ScanAdd = {}));
    let AttendanceView;
    (function (AttendanceView) {
        AttendanceView["PERSONAL"] = "Personal";
        AttendanceView["OTHER"] = "Other";
    })(AttendanceView = Permissions.AttendanceView || (Permissions.AttendanceView = {}));
    let ViewAccountNotifications;
    (function (ViewAccountNotifications) {
        ViewAccountNotifications["NO"] = "No";
        ViewAccountNotifications["YES"] = "Yes";
    })(ViewAccountNotifications = Permissions.ViewAccountNotifications || (Permissions.ViewAccountNotifications = {}));
    let CreateEventAccount;
    (function (CreateEventAccount) {
        CreateEventAccount["NO"] = "No";
        CreateEventAccount["YES"] = "Yes";
    })(CreateEventAccount = Permissions.CreateEventAccount || (Permissions.CreateEventAccount = {}));
    let MemberSearch;
    (function (MemberSearch) {
        MemberSearch["NO"] = "No";
        MemberSearch["YES"] = "Yes";
    })(MemberSearch = Permissions.MemberSearch || (Permissions.MemberSearch = {}));
})(Permissions = exports.Permissions || (exports.Permissions = {}));
var AccountType;
(function (AccountType) {
    AccountType["CAPSQUADRON"] = "CAPSquadron";
    AccountType["CAPGROUP"] = "CAPGroup";
    AccountType["CAPWING"] = "CAPWing";
    AccountType["CAPREGION"] = "CAPRegion";
    AccountType["CAPEVENT"] = "CAPEvent";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var SigninKeyScopeType;
(function (SigninKeyScopeType) {
    SigninKeyScopeType["GLOBAL"] = "Global";
    SigninKeyScopeType["ACCOUNT"] = "Account";
    SigninKeyScopeType["USER"] = "User";
})(SigninKeyScopeType = exports.SigninKeyScopeType || (exports.SigninKeyScopeType = {}));
var SigninTokenType;
(function (SigninTokenType) {
    SigninTokenType["RECAPTCHA"] = "Recaptcha";
    SigninTokenType["SIGNATURE"] = "Signature";
})(SigninTokenType = exports.SigninTokenType || (exports.SigninTokenType = {}));
var SessionType;
(function (SessionType) {
    SessionType["REGULAR"] = "Regular";
    SessionType["PASSWORD_RESET"] = "PasswordReset";
    SessionType["SCAN_ADD"] = "ScanAdd";
    SessionType["IN_PROGRESS_MFA"] = "MFAInProgress";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
//# sourceMappingURL=types.js.map